// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CollapseTokens } from './type';

const collapseTokens: CollapseTokens = {
  collapseIconColor: 'Neutral-text-4',
  collapseIconHoverBackgroundColor: 'Neutral-fill-3',
  collapseExtraMargin: 'Margin-24',
  collapseWrapperBorderSize: 'Border-1',
  collapseWrapperBorderRadius: 'Radius-4',
  collapseWrapperGap: 'Size-12',
  collapseWrapperPaddingX: 'Padding-16',
  collapseWrapperPaddingY: 'Padding-12',
  collapseHeaderLineHeight: 'Size-11',
  collapseHeaderGap: 'Size-4',
  collapseHeaderFontSize: '14/regular',
  collapseHeaderWeight: '400',
  collapseHeaderIconWidth: 'Size-7',
  collapseHeaderExtraGap: 'Size-5',
  collapseContentLineHeight: 'Size-11',
  collapseContentGap: 'Size-12',
  collapseContentPaddingY: 'Padding-12',
  collapseContentFontSize: '14/regular',
  collapseContentWeight: '400',
  collapseContentPaddingLeft: 'Size-19',
  collapseContentPaddingRight: 'Padding-16',
  collapseWrapperBorderColor: 'Neutral-border-1',
  collapseWrapperColor: 'Neutral-border-1',
  collapseWrapperBackgroundColor: 'Neutral-fill-1',
  collapseHeaderColor: 'Neutral-text-5',
  collapseContentColor: 'Neutral-text-4',
  collapseContentBackgroundColor: 'Neutral-fill-2',
  collapseDisabledColor: 'Neutral-text-2',
};

export default collapseTokens;
